import createReducer from '../utils/createReducer';
import actions from '../actions/actions';

export const initialState = {
    adultsCount: 2,
    childrenCount: 0,
    petIncluded: false,
    arrival: null,
    departure: null,
    location: '',
    searchUrl: ''
};

const actionHandlers = {};

const mergeStates = (newState) => {
    return {
        adultsCount: newState.adultsCount || initialState.adultsCount,
        childrenCount: newState.childrenCount || initialState.childrenCount,
        petIncluded: newState.petIncluded || initialState.petIncluded,
        arrival: newState.arrival || initialState.arrival,
        departure: newState.departure || initialState.departure,
        location: newState.location || initialState.location,
        searchUrl: newState.searchUrl || initialState.searchUrl
    };
};

actionHandlers[actions.UPDATE_TRIP_DATA] = (_, {payload}) => {
    const newState = {
        ...mergeStates(payload)
    };
    return newState;
};

actionHandlers[actions.INIT_TRIP_DATA] = (_, {payload}) => {
    const newState = {
        ...mergeStates(payload)
    };
    return newState;
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/reducers/trip.js